import React, { createContext, useContext, useState } from 'react';

const ChatContext = createContext();

export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context;
};

export const ChatProvider = ({ children }) => {
  const [openChatRoom, setOpenChatRoom] = useState(null);
  const [isChatOpen, setIsChatOpen] = useState(false);

  // Function to open a specific chat room
  const openChatRoomById = (chatRoomId, chatData = null) => {
    setOpenChatRoom({ chatRoomId, chatData });
    setIsChatOpen(true);
  };

  // Function to close chat
  const closeChat = () => {
    setOpenChatRoom(null);
    setIsChatOpen(false);
  };

  // Function to open chat without specific room (just open the chat component)
  const openChat = () => {
    setIsChatOpen(true);
  };

  const value = {
    openChatRoom,
    isChatOpen,
    openChatRoomById,
    closeChat,
    openChat,
    setOpenChatRoom,
    setIsChatOpen
  };

  return (
    <ChatContext.Provider value={value}>
      {children}
    </ChatContext.Provider>
  );
};
